import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { TripSummaryService } from '@common/services/my-booking/trip-summary.service';
import { SupportComponent } from '@lib/components/support-class';
import { DateFormatPipe } from '@lib/pipes';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-estimate-datetime',
  templateUrl: './estimate-datetime.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstimateDateTimeComponent extends SupportComponent {
  @Input() newDateTime: string = '';
  @Input() oldDateTime: string = '';
  @Input() isArrival: boolean = false;

  isEqualDateTime: boolean = false;
  isEstimateLessThan: boolean = false;

  // (1.1.22) 最新出発日時 & (1.1.50) 最新到着時刻
  get estimate(): string {
    return this.isArrival || this.isEqualDateTime
      ? /** 1.1)
         * 当該セグメント.departure.estimatedDateTime(yyyy-MM-dd) =
         * 当該セグメント.departure.dateTime(yyyy-MM-dd)の場合、
         * 当該セグメント. departure.estimatedDateTime(時刻フォーマット)を表示する
         */
        this._dateFormat.transform(this.newDateTime, 'default_departuredate.time') ?? ''
      : /** 1.2)
         * 当該セグメント.departure.estimatedDateTime(yyyy-MM-dd) ≠
         * 当該セグメント.departure.dateTime(yyyy-MM-dd)の場合、
         * 当該セグメント. departure.estimatedDateTime(月日 + 時刻フォーマット)を表示する
         */
        this._dateFormat.transform(this.newDateTime, 'default_departuredate.dateTime');
  }

  constructor(
    public tripSummarySvc: TripSummaryService,
    private _dateFormat: DateFormatPipe,
    private _date: DatePipe,
    private _change: ChangeDetectorRef,
    private _common: CommonLibService
  ) {
    super(_common);
  }

  override init(): void {
    this.isEqualDateTime = this.newDateTime === this.oldDateTime;
    this.isEstimateLessThan = this.newDateTime < this.oldDateTime;
    this._change.markForCheck();
  }

  override reload(): void {
    // Add comment to passed SonarLint
  }

  override destroy(): void {
    // Add comment to passed SonarLint
  }
}
